import React, { useState, useEffect } from "react";
import { RiMoonFill, RiSunFill, RiUser3Line, RiSettings3Line } from "react-icons/ri";
import "./FixedPlugin.css";

export default function FixedPlugin() {
  const [darkmode, setDarkmode] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [user, setUser] = useState(null);

  const togglePanel = () => setIsOpen(!isOpen);
  const toggleSettings = () => setShowSettings(!showSettings);

  useEffect(() => {
    // Get user info from localStorage
    const userInfo = JSON.parse(localStorage.getItem('user')) || {};
    setUser(userInfo);
    
    // Check for existing dark mode preference
    const savedDarkMode = localStorage.getItem('darkMode') === 'true';
    setDarkmode(savedDarkMode);
    
    // Apply dark mode on load
    if (savedDarkMode) {
      document.documentElement.classList.add('dark');
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('.fixed-plugin')) {
        setIsOpen(false);
        setShowSettings(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  const toggleDarkMode = () => {
    const newDarkMode = !darkmode;
    setDarkmode(newDarkMode);
    localStorage.setItem('darkMode', newDarkMode.toString());
    
    // Apply dark mode to document root and body
    if (newDarkMode) {
      document.documentElement.classList.add('dark');
      document.body.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
      document.body.classList.remove('dark');
    }
  };

  return (
    <div className="fixed-plugin">
      <div className="plugin-inner">
        <button className="plugin-button" onClick={togglePanel}>
          <div className="plugin-icon">
            <RiUser3Line />
          </div>
        </button>

        {isOpen && (
          <div className="profile-panel">
            <div className="profile-header">
              <div className="profile-avatar">
                {user?.profilePic ? (
                  <img src={user.profilePic} alt="Profile" />
                ) : (
                  <div className="profile-placeholder">
                    {user?.name ? user.name.charAt(0).toUpperCase() : 'U'}
                  </div>
                )}
              </div>
              <div className="profile-info">
                <h3>{user?.name || 'User'}</h3>
                <p>{user?.role || 'Staff'}</p>
              </div>
            </div>
            <div className="profile-actions">
              <button className="profile-action-btn">
                <RiUser3Line />
                <span>View Profile</span>
              </button>
              <button 
                className="profile-action-btn"
                onClick={toggleSettings}
              >
                <RiSettings3Line />
                <span>Settings</span>
              </button>
              <button 
                className="profile-action-btn profile-logout-button"
                onClick={() => {
                  window.location.href = '/logout';
                }}
              >
                <RiSunFill />
                <span>Logout</span>
              </button>
            </div>
            
            {showSettings && (
              <div className="settings-panel">
                <h4>Settings</h4>
                <button
                  className="theme-toggle"
                  onClick={toggleDarkMode}
                >
                  {darkmode ? (
                    <RiSunFill className="theme-icon" />
                  ) : (
                    <RiMoonFill className="theme-icon" />
                  )}
                  <span>{darkmode ? 'Light Mode' : 'Dark Mode'}</span>
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
